// App-level navigation state.

export type View = 'studio' | 'animate' | 'scene' | 'gallery' | 'admin';

export const ui = $state({ view: 'studio' as View });
